import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ApiError } from '@/api/client';
import { Alert, Button, Field } from '@/components/ui';
import { AuthShell } from './AuthShell';
import { useAuth } from './AuthContext';
import styles from './auth.module.css';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/tippuebersicht';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login({ email, password });
      navigate(from, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.code === 'account_not_active') {
        setError(
          'Dein Konto ist noch nicht freigeschaltet. Bitte warte auf die Freigabe durch einen Admin.',
        );
      } else if (err instanceof ApiError && err.status === 401) {
        setError('E-Mail oder Passwort ist falsch.');
      } else {
        setError(err instanceof Error ? err.message : 'Anmeldung fehlgeschlagen.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell>
      <h1 className={styles.cardTitle}>Anmelden</h1>
      <p className={styles.cardLead}>Willkommen zurück!</p>
      {error && <Alert>{error}</Alert>}
      <form onSubmit={onSubmit} noValidate>
        <Field
          id="email"
          label="E-Mail"
          type="email"
          autoComplete="email"
          inputMode="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Field
          id="password"
          label="Passwort"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Anmelden…' : 'Anmelden'}
        </Button>
      </form>
      <p className={styles.altLink}>
        Noch kein Konto? <Link to="/register">Registrieren</Link>
      </p>
    </AuthShell>
  );
}
